import { useTranslation } from "react-i18next"

import { useFormatDateRange } from "@/formatters"
import type { IDateFormat } from "@/models/date/date"
import { baseColumnDef } from "@/nzds/data-grid"
import { PERIOD_DATE_FORMAT } from "@/utils/date"
import { getStringValue } from "@/utils/value"

import type { GridColDef, GridValidRowModel } from "@mui/x-data-grid-pro"

interface UsePeriodColumnOptions {
  endField?: string
  filterable?: boolean
  format?: IDateFormat
  startField?: string
  timeZone?: string
}

export const usePeriodColumn = <TRow extends GridValidRowModel>(
  options: UsePeriodColumnOptions = {}
): GridColDef<TRow> => {
  const { t } = useTranslation("common")
  const endField = options.endField ?? "end_date"
  const filterable = options.filterable ?? false
  const format = options.format ?? PERIOD_DATE_FORMAT
  const startField = options.startField ?? "start_date"
  const timeZone = options.timeZone
  const { formatDateRange } = useFormatDateRange(format)

  return {
    ...baseColumnDef,
    field: startField,
    filterable,
    flex: 1,
    headerName: t("fields.period.title"),
    maxWidth: 360,
    minWidth: 220,
    sortable: true,
    valueFormatter: (_value, row) => {
      const rowRecord = row as Record<string, unknown>

      return formatDateRange(
        getStringValue(rowRecord[startField]),
        getStringValue(rowRecord[endField]),
        { timeZone }
      )
    },
  }
}
